// @ts-nocheck
import React, { createContext } from "react";

import {  type MemberDetailsStateType } from "@myk";
const MemberContext: React.Consumer<MemberDetailsStateType> = createContext({});

MemberContext.displayName = "MemberContext";

export default MemberContext;
